import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import { getFromStorage } from "../../../utils/imageUtil";
import { formatTimeHHMMSS } from "../../../utils/time";
import React, { useEffect, useState } from "react";
import { IUserModel, MatchModel } from "../../../types/types";

const FightStartScreen = ({
                            bet,
                            user,
                            setBet,
                            fightCooldownRemaining,
                            loading,
                            onStartClick,
                            isPvp,
                            setIsPvp,
                            pendingMatches,
                            acceptMatch
                          }: {
  bet: number;
  user: IUserModel;
  setBet: (bet: number) => void;
  fightCooldownRemaining: number;
  loading: boolean;
  onStartClick: () => void;
  isPvp: boolean;
  setIsPvp: (isPvp: boolean) => void;
  pendingMatches: MatchModel[] | null;
  acceptMatch: (matchId: number) => Promise<void>;
}) => {
  const [maxBet, setMaxBet] = useState(user.tonBalance ?? 0 > 100 ? 100 : user.tonBalance);
  const {t} = useTranslation();

  const defaultBet = user.miningPower * 3600 * 3;

  const handleChange = (e: any) => {
    const value = Number(e.target.value);
    setBet(value);
  };

  const progress = ((bet - 1) / (maxBet - 1)) * 100; // Calculate progress percentage

  useEffect(() => {
    setBet(0);
    if (isPvp) {
      const maxTonBet: number = user.tonBalance ?? 0 > 100 ? 100 : user.tonBalance ?? 0;
      setMaxBet(maxTonBet);
    } else {
      const maxCoinBet = user.coins >= defaultBet ? defaultBet : user.coins;
      setMaxBet(maxCoinBet);
    }
  }, [isPvp])


  return (
    <div className="text-center flex flex-col h-full p-2 gap-2 overflow-y-auto">
      {
        !loading && (
          <div
            className="flex justify-around gap-2 p-2 items-center w-full rounded-2xl shadow-md border-t bg-stone-800 border-gray-700 z-10 top-6">
            <button
              onClick={ () => setIsPvp(true) }
              className={ `w-full py-1 rounded-lg transition-colors ${ isPvp ? 'bg-gray-600 text-white' : 'text-gray-500' }` }
            >
              PvP
            </button>
            <button
              onClick={ () => setIsPvp(false) }
              className={ `w-full py-1 rounded-lg transition-colors ${ !isPvp ? 'bg-gray-600 text-white' : 'text-gray-500' }` }
            >
              PvE
            </button>
          </div>
        )
      }
      <div className={ `text-center flex flex-col gap-4 p-2 ${ isPvp ? '' : 'h-full' }` }>
        <div className={ 'flex justify-center w-full rounded-2xl overflow-hidden max-h-64' }>
          <img
            className={ 'object-fill h-full' }
            src={ getFromStorage('fight_bg.jpg') }
            alt=""
          />
        </div>
        <p className="text-2xl">{ t("app.fight.doYouWantStart") }</p>
        <div className="w-[90%] mx-auto flex flex-col gap-2">
          <label htmlFor="bet" className={ 'flex justify-center gap-2' }>
            { parse(t("app.fight.yourBetIs", {bet: `<span class="text-gold text-xl">${ bet }</span>`}).toString()) }
            <div className={ 'w-6 h-6' }>
              <img src={ getFromStorage(isPvp ? 'ton.svg' : 'coin.webp') } alt="" className={ 'w-full h-full' }/>
            </div>
          </label>
          <div className="w-full relative flex my-4">
            <input
              className="range-slider"
              type="range"
              id="bet"
              min="1"
              max={ maxBet }
              value={ bet }
              onChange={ handleChange }
              style={ {
                background: `linear-gradient(to right, #052e16 0%, #052e16 ${ progress }%, whitesmoke ${ progress }%, whitesmoke 100%)`,
              } }
            />
          </div>
        </div>
      </div>
      {
        !isPvp && (
          <div className={ 'grow' }></div>
        )
      }
      <div className={ 'w-full min-h-12 content-center shadow-md overflow-hidden' }>
        {
          loading ?
            <button className={ "bg-graySecondary rounded-2xl py-3 px-6 w-full h-12 overflow-hidden" }>Searching...</button>
            :
            !isPvp && fightCooldownRemaining > 0 ?
              (
                <button className={ "bg-graySecondary rounded-2xl py-3 px-6 w-full h-12 overflow-hidden" }>
                  { formatTimeHHMMSS(fightCooldownRemaining) }
                </button>
              )
              :
              (
                <button
                  className={ `w-full rounded-2xl  bg-amber-900 py-3 px-6 h-12 block relative overflow-hidden clickable font-semibold text-xl` }
                  onClick={ onStartClick }
                >
                  <span>{ t("app.fight.startGame") }</span>
                </button>
              )
        }
      </div>
      {
        isPvp && (
          <ul className={ 'flex flex-col gap-2' }>
            {
              pendingMatches != null && pendingMatches.map((item, index) => (
                <li key={ index } className={ 'rounded-2xl overflow-hidden' }>
                  <div className={ 'flex gap-2 w-full h-16 py-2 px-4 bg-gray-primary' }>
                    <div className={ "relative" }>
                      <span
                        className={ "absolute block text-gold text-xl -bottom-2 right-0 font-semibold" }>{ user.level }</span>
                      <div className={ 'h-12 w-12 rounded-full overflow-hidden' }>
                        <img
                          className={ "h-full w-full object-contain" }
                          src={ item.creator.photoUrl ?? getFromStorage(`${ item.creator.race }.webp`) }
                          alt={ '' }
                        />
                      </div>
                    </div>
                    <div className={ 'flex flex-col justify-between text-left grow' }>
                      <div className={ '' }>
                        {
                          item.creator.username ?? item.creator.firstName + " " + item.creator.lastName ?? ""
                        }
                      </div>
                      <div className={ 'flex gap-2 h-5 leading-5' }>
                        {
                          t('Bet: ') + item.bet
                        }
                        <div className={ 'w-5 h-5' }>
                          <img className={ 'h-full w-full' } src={ getFromStorage('ton.svg') } alt=""/>
                        </div>
                      </div>
                    </div>
                    <div className={ 'flex flex-col justify-center' }>
                      <div className={ 'px-4 py-2 bg-green-950 rounded-full cursor-pointer' }
                           onClick={ () => acceptMatch(item.id) }>
                        { t('Accept') }
                      </div>
                    </div>
                  </div>
                </li>
              ))
            }
          </ul>
        )
      }
    </div>
  );
};

export default FightStartScreen;
